import React, { useState } from 'react';

export default function RoleCard({ roleInfo, compact = false }) {
  const [revealed, setRevealed] = useState(false);

  if (!roleInfo) return null;

  const { role, alignment, knownPlayers, roleDescription } = roleInfo;

  if (!revealed && !compact) {
    return (
      <div className="role-reveal">
        <div
          className={`role-card ${alignment}`}
          onClick={() => setRevealed(true)}
          style={{ cursor: 'pointer' }}
        >
          <div className={`alignment-label ${alignment}`}>
            Tap to reveal your role
          </div>
          <div className="role-name-display" style={{ fontSize: '1.2rem', opacity: 0.5 }}>
            ?
          </div>
        </div>
        <div className="tap-reveal">Tap the card above to see your secret role</div>
      </div>
    );
  }

  return (
    <div className={`role-card ${alignment}`} onClick={() => !compact && setRevealed(false)}>
      <div className={`alignment-label ${alignment}`}>
        {alignment === 'good' ? 'Loyal to Arthur' : 'Servant of Evil'}
      </div>
      <div className="role-name-display">{role}</div>
      {!compact && (
        <>
          <div className="role-description">{roleDescription}</div>
          {knownPlayers && knownPlayers.length > 0 && (
            <div className="known-players">
              <div className="known-header">
                {alignment === 'evil' ? 'Your evil teammates' :
                 role === 'Merlin' ? 'Evil players revealed to you' :
                 role === 'Percival' ? 'One of these is Merlin' :
                 'Known information'}
              </div>
              {knownPlayers.map((kp) => (
                <div key={kp.id} className="known-player">
                  <span className={`known-dot ${
                    kp.label === 'Merlin?' ? 'merlin' : 'evil'
                  }`} />
                  <span className="known-name">{kp.name}</span>
                  <span className="known-label">{kp.label}</span>
                </div>
              ))}
            </div>
          )}
          <div className="tap-reveal" style={{ marginTop: '12px' }}>
            Tap card to hide
          </div>
        </>
      )}
    </div>
  );
}
